import { api } from '../main-api/apiClient';

// Tenant Nurse Recording Review API services
export const tenantNurseRecordingAPI = {
  // Get patient recordings
  getPatientRecordings: (patientId, params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/tenant-nurse/patients/${patientId}/recordings?${queryString}`);
  },
  
  // Get recording session details
  getRecordingDetails: (sessionId) => {
    return api.get(`/tenant-nurse/recordings/${sessionId}/details`);
  },
  
  // Get patient care summary
  getPatientCareSummary: (patientId) => {
    return api.get(`/tenant-nurse/patients/${patientId}/care-summary`);
  }
};

export default tenantNurseRecordingAPI;